import React from 'react';
import ReactDOM from 'react-dom';

import en from './i18n/en.js';
import * as i18n from '../common/i18n';
import ForgotPassword from './components/forgot-password';

i18n.initialize({ 
  debug: process.env.NODE_ENV === 'development', // eslint-disable-line no-undef
  defaultNS: 'forgot_password',
  resources: { en },
}).then(() => {
  ReactDOM.render(
    <ForgotPassword />,
    document.getElementById('entry')
  );
});

